export default __webpack_public_path__ + "static/elena-6a51d85612a469424200cca4beef4323.jpg";